<template>
  <div>
    <div class="vx-row" id="formulation_qa_table">
      <div class="vx-col w-full">
        <vx-card no-shadow>

          <template slot="actions">
            <vs-button v-if="$canAll(formulationPermissions)" @click="onClickFormulaApplicationUpdate" class="mr-0" color="primary"
                       size="small" type="filled">Application Add/Update
            </vs-button>
            <vs-button v-if="$canAll(formulationPermissions)" @click="onClickFormulaApplicationManage" class="ml-4" color="primary"
                       size="small" type="filled">Formulation Applications Manager
            </vs-button>
          </template>

          <div slot="no-body" class="mt-4">

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <!-- <small class="label">Dosage Info</small> --> 
                <small class="label">MAX Dosage</small>
                <vs-textarea class="mb-0" v-model="formulation.dosage_info" height="50px"/>
              </div>
            </div>

            <div class="vx-row mb-8" v-if="$canAll(formulationPermissions)">
              <div class="vx-col">
                <vs-button @click="onClickSaveDosage" class="mr-0 ml-auto float-right" color="primary"
                           size="small" type="filled">Save changes
                </vs-button>
              </div>
            </div>

            <vs-table :data="applications" :sst="true" stripe
                      class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="25%" sort-key="contact_1">NAME</vs-th>
                <vs-th width="25%" class="float-left">DESCRIPTION</vs-th>
                <vs-th width="25%" sort-key="email">CODE</vs-th>
                <vs-th width="25%">ACTIVE STATUS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                  </vs-td>

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    <vs-chip transparent v-if="data[indextr].is_active" color="primary">
                      active
                    </vs-chip>
                    <vs-chip transparent v-if="!data[indextr].is_active" color="warning">
                      de-active
                    </vs-chip>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
          </div>

        </vx-card>

      </div>
    </div>
    <formulation-application-pop-up ref="formulationApplicationPopUp"/>
    <formulation-application-manage-pop-up ref="formulationApplicationManagePopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const FormulationsRepository = RepositoryFactory.get('formulations')
import {VTree, VSelectTree} from 'vue-tree-halower'
import FormulationApplicationPopUp from '@/components/popups/formulations/applications/FormulationApplicationPopUp'
import FormulationApplicationManagePopUp
  from '@/components/popups/formulations/applications/FormulationApplicationManagePopUp'

export default {
  name: "FormulationApplicationsTab",
  components: {
    VTree,
    VSelectTree,
    FormulationApplicationPopUp,
    FormulationApplicationManagePopUp
  },
  data() {
    return {
      formulationId: '',
      applications: [],
      treeData: [],
      formulation: {},
    }
  },
  props: {
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async refreshData() {
      await this.loadFormulations()
      this.$emit('refreshGeneral')
    },
    async loadFormulations() {
      await this.$vs.loading({
        container: '#formulation_qa_table',
        scale: 0.45
      })
      const {data} = await FormulationsRepository.details(this.formulationId)
      this.formulation = data.data
      this.applications = this.formulation.application_items

      // const {data} = await FormulationsRepository.getFormulaApplications()
      // this.applications =  data.data
      const nest = (items, id = null, link = 'parent_id') => items
        .filter(item => item[link] === id)
        .map(item => ({
          ...item,
          children: nest(items, item.id),
          name: item.name,
          description: item.description,
          expanded: false,
          nocheck: true,
          code: item.code,
          is_active: item.is_active
        }))
      // (nest(items, item.Id)).length > 0

      this.treeData = nest(this.applications)
      this.$vs.loading.close('#formulation_qa_table > .con-vs-loading')
    },
    tpl(...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>
          <span class={titleClass} domPropsInnerHTML={node.code + ' - ' + node.name} onClick={() => {
            this.$refs.tree.nodeSelected(node)
          }}></span>
          <button class="btn-async text-warning border-none cursor-pointer px-2 py-1 mr-2 rounded"
                  onClick={() => this.asyncLoad(node)}>update</button>
          <button class="btn-delete text-danger border-none cursor-pointer px-2 py-1 rounded"
                  onClick={() => this.$refs.tree.delNode(node, parent, index)}>delete</button>
          </span>
    },
    async onClickFormulaApplicationUpdate() {
      await this.$refs.formulationApplicationPopUp.openPopup(this.formulationId)
    },
    async onClickFormulaApplicationManage() {
      await this.$refs.formulationApplicationManagePopUp.openPopup(this.formulationId)
    },
    async onClickSaveDosage() {
      try {
        const application_items = this.applications.map((x) => x.id)
        await FormulationsRepository.updateFormulationsApplications(this.formulationId, { application_items: application_items, dosage_info: this.formulation.dosage_info })
        this.showSuccessMessage('Formulation dosage information updated');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    // async asyncLoad (node) {
    //   const {checked = false} = node
    //   this.$set(node, 'loading', true)
    //   let pro = new Promise(resolve => {
    //     setTimeout(resolve, 2000, ['async node1', 'async node2'])
    //   })
    //   this.$refs.tree.addNodes(node, await pro)
    //   this.$set(node, 'loading', false)
    //   if (checked) {
    //     this.$refs.tree.childCheckedHandle(node, checked)
    //   }
    // },
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    await this.loadFormulations()
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style lang="scss">

.__table-heading-small {
  font-size: x-small;
  font-weight: normal;
}

@import "@/assets/scss/vuexy/extraComponents/tree.scss";

button.btn-async {
  background: rgba(var(--vs-warning), 0.15);
}

button.btn-delete {
  background: rgba(var(--vs-danger), 0.15);
}

</style>
